import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { SmsUsageResponse } from '@app/core/models/notification-usage.interface';

// Mock-mode handler for GET /:tenantId/notifications/sms-usage. Echoes the
// requested window (or a current-month default) with a plausible sent count so
// both the workshop and admin screens have something to render offline.
@Injectable({ providedIn: 'root' })
export class NotificationUsageMocksService {
  handleMockRequest(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    if (req.method === 'GET' && req.url.includes('/notifications/sms-usage')) {
      const url = new URL(req.url);
      const segments = url.pathname.split('/');
      const tenantId = parseInt(segments[segments.indexOf('notifications') - 1] || '1', 10);
      const { from, to } = this.currentMonthRange();

      const body: SmsUsageResponse = {
        tenantId,
        from: url.searchParams.get('from') || from,
        to: url.searchParams.get('to') || to,
        smsSent: 142,
      };
      return of(new HttpResponse({ status: 200, body })).pipe(delay(400));
    }

    throw new Error(`Unsupported mock notification-usage request: ${req.method} ${req.url}`);
  }

  // Matches the backend's current-month default: first-of-month..today.
  private currentMonthRange(): { from: string; to: string } {
    const now = new Date();
    const first = new Date(now.getFullYear(), now.getMonth(), 1);
    return { from: this.toIsoDate(first), to: this.toIsoDate(now) };
  }

  private toIsoDate(d: Date): string {
    return d.toISOString().slice(0, 10);
  }
}
